<template>
  <b-modal
    v-if="tracks!=null"
    ref="modal"
    centered
    :visible="tracks.length > 0"
    @hidden="cancelModal"
    modal-class="modal-condensed"
  >
    <template slot="modal-header">
      <h1>{{ Translations.sections.tracks.edition.tags }}</h1>
      <div>
        <Button
          :empty="true"
          class="close-popup"
          @click.prevent="cancelModal"
        >{{ Translations.buttons.cancel }}</Button>
        <Button :empty="false" :noBorder="true" class="validate" @click.prevent="updateTracks">Done</Button>
      </div>
    </template>
    <template>
      <div class="flex-container">
        <div class="form-container search">
          <input
            type="text"
            v-focus
            maxlength="100"
            placeholder="Search Tags"
            v-model="searchData.searchTerm"
          />
        </div>
        <div class="search-result">
          <WaitingBlock v-if="modalState.isLoadingTags" />
          <template v-else-if="searchResult != null">
            <div
              v-if="searchResult.dataItem && searchResult.dataItem && searchResult.dataItem.length"
            >
              <div
                v-for="tag in filteredTags2"
                :key="tag.id"
                :class="['tag-container',{'selected' : selectedTags[tag.id] !== undefined}]"
                @click.prevent="toggleTag(tag)"
              >
                <i
                  :class="['far', selectedTags[tag.id] === undefined ? 'fa-square':'fa-check-square']"
                ></i>
                <span class="name">{{tag.name}}</span>
              </div>
            </div>
          </template>
          <div v-if="noResult" class="no-result-container">
            <header>
              <strong>No tag matching your search criteria</strong>
            </header>
          </div>
        </div>
      </div>
    </template>
    <template slot="modal-footer">
      <div class="selection-container">
        <template v-if="selectedTagsData.length>0">
          <header>{{selectedTagsData.length}} selected tags :</header>
          <section>
            <div
              v-for="tag in selectedTagsData.tags"
              :key="tag.id"
              :class="['badge', 'style-badge',{'selected' : selectedTags[tag.id] === undefined}]"
            >
              <span class="name">{{tag.name}}</span>
              <span class="selector">
                <i class="fas fa-trash" @click.prevent="toggleTag(tag)"></i>
              </span>
            </div>
          </section>
        </template>
      </div>
      <!--<Button :empty="true" class="close-popup" @click.prevent="cancelModal">{{ Translations.buttons.cancel }}</Button>
            <Button :empty="false" class="validate" @click.prevent="updateTracks">
                Update {{tracks.length}} track(s)
      </Button>-->
    </template>
  </b-modal>
</template>

<script>
import Vue from "vue";
import Button from "@/components/common/Button";
import Bootstrap from "bootstrap-vue";
import store from "@/store";
import router from "@/router";
import Translations from "@/store/translations";
import EventBus from "@/eventbus";
import Portlet from "@/components/common/Portlet.vue";
import { HTTP } from "@/utils/http";
import Apis from "@/apis/index";
import { mapState } from "vuex";
import WaitingBlock from "@/components/common/WaitingBlock";

export default {
  name: "SelectorTags",
  components: { Portlet, Bootstrap, Button, WaitingBlock },
  computed: {
    Translations: () => Translations,
    trackUids() {
      return this.tracks.map(track => track.uid);
    },
    selectedTagsData() {
      return {
        length: Object.keys(this.selectedTags).length,
        tags: Object.values(this.selectedTags)
      };
    },
    filteredTags2() {
      const { searchData, searchResult } = this;
      const searchQuery =
        searchData.searchTerm && typeof searchData.searchTerm === "string"
          ? searchData.searchTerm.trim()
          : "";
      if (
        searchQuery.length &&
        searchResult &&
        searchResult.dataItem &&
        searchResult.dataItem.length
      ) {
        const normalizedSearchQuery = this.normalizeSearchTerm(searchQuery);
        const filteredList = searchResult.dataItem.filter(tag => {
          return this.normalizeSearchTerm(tag.name).includes(searchQuery);
        });
        const sortedList = filteredList.sort((a, b) => b.name - a.name);
        this.noResult = sortedList.length ? false : true;
        return sortedList;
      }
      this.noResult = false;
      return searchResult.dataItem;
    }
  },
  mounted() {
    this.search();
  },
  directives: {
    focus: {
      // When the bound element is inserted into the DOM...
      inserted: function(el) {
        // hack to trigger inside method
        setTimeout(() => {
          el.focus();
        }, 0);
      }
    }
  },
  props: {
    stationUid: { required: true },
    multiselect: { required: false, default: true },
    noModalEdit: null
  },
  data() {
    return {
      modalState: {
        hasSearchProcessed: false,
        isLoadingTags: false,
        delayedSearch: null
      },
      tracks: [],
      selectedTags: {},
      searchResult: null,
      searchData: {
        searchTerm: "",
        pageSize: 50,
        page: 1
      },
      noResult: false
    };
  },
  methods: {
    normalizeSearchTerm(str) {
      console.log("str", str);
      return str
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase();
    },
    // ------------------------------------------------------
    /* Start : Common Behaviour */
    // ------------------------------------------------------
    handleSubmit() {},
    show() {
      this.$refs.modal.show();

      if (this.$refs.inputSearch) {
        this.$refs.inputSearch.focus();
      }
    },
    edit(tags) {
      const tgs = tags.reduce((acc, item) => {
        acc[item.id] = item;
        return acc;
      }, {});

      this.selectedTags = tgs;
      this.show();
    },
    editForTracks(tracks) {
      var tmpTags = {};
      this.tracks = tracks;

      if (this.tracks.length == 1) {
        for (var i = 0; i < (this.tracks[0].tags || []).length; i++) {
          tmpTags[this.tracks[0].tags[i].id] = this.tracks[0].tags[i];
        }
      }

      this.selectedTags = tmpTags;
      this.show();
    },
    searchDelay(delay) {
      if (this.delayedSearch != null) clearTimeout(this.delayedSearch);
      this.delayedSearch = setTimeout(this.search, delay || 150);
    },
    search() {
      this.modalState.isLoadingTags = true;
      try {
        HTTP.get(Apis.parameters.tags)
          .then(this.searchEnd)
          .catch(this.searchError)
          .then(this.searchCompleted);
      } catch (e) {
        console.log(e);
      }
    },
    searchEnd(response) {
      this.searchResult = response.data;
    },
    searchError(response) {
      this.searchResult = response.data;
    },
    searchCompleted(response) {
      this.modalState.isLoadingTags = false;
      this.modalState.hasSearchProcessed = true;
    },
    cancelModal() {
      this.modalState.hasSearchProcessed = true;
      this.searchData.searchTerm = "";
      if (document.activeElement) {
        document.activeElement.blur();
      }
      this.$emit("onHidden");
      this.$refs["modal"].hide();
    },
    // ------------------------------------------------------
    /* End : Common Behaviour */
    // ------------------------------------------------------
    async updateTracks() {
      var result = null;

      if (this.noModalEdit) {
        this.cancelModal();
        this.$emit("newValue", "tags", this.selectedTagsData.tags);
        return;
      }

      try {
        console.log("in try selectedDataTags :", this.selectedTagsData);
        var data = {
          stationUid: this.stationUid,
          keys: this.trackUids,
          values: this.selectedTagsData.tags.map(item => {
            return item.id;
          })
        };

        result = await HTTP.post(Apis.library.tracks.update.tags, data);

        if (result.data.dataItem != null) {
          for (var idxTrack in this.tracks) {
            var track = this.tracks[idxTrack];
            var uid = track.uid;
            if (uid === undefined) continue;
            var updatedTrack = result.data.dataItem[uid];
            if (updatedTrack != null) {
              track.tags = updatedTrack.tags || [];
              track.warnings = updatedTrack.warnings;
              track.isFilled = updatedTrack.isFilled;
              this.cancelModal();
            }
          }
        }
      } catch (error) {
        console.log("errrrror in updateTracks", error, error.response);
        result = error.response.data;
        console.log("Update Result Error:", error);
      }
      if (result != null && result.errors && result.errors.length == 0) {
        this.cancelModal();
      } else {
        // an error occured : show it
      }
    },
    toggleTag(tag) {
      tag.isSelected = !tag.isSelected;
      if (this.selectedTags[tag.id] != null) {
        Vue.delete(this.selectedTags, tag.id);
      } else {
        if (!this.multiselect) {
          this.selectedTags = {};
        }

        const newTag = tag;
        newTag.displayOrder = new Date().getTime();
        this.selectedTags = { ...this.selectedTags, [tag.id]: newTag };
        // this.$set(this.selectedTags, tag.id, Object.assign({ displayOrder: new Date().getTime() }, tag))
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.tag-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 10px;
  cursor: pointer;
  /* border-radius: 4px; */
}

.no-result-container header {
  padding: 20px 25px;
}

.name {
  width: 100%;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  flex-shrink: 0;
  margin: 0 1em;
}

.selector i,
.visible i {
  cursor: pointer;
}

.flex-container {
  display: flex;
  flex-direction: column;
}

.form-container {
  padding: 10px 25px;
  background: white;
}

.form-container.search {
  box-shadow: 0 5px 5px -5px #d2d2d2;
  position: sticky;
  top: 0px;
}

.search-container {
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.selection-container {
  background: white;
  max-height: 150px;
  overflow-y: auto;
  display: block;
  box-shadow: 0 -5px 5px -5px white;
  width: 100%;
}

.selection-container header {
  position: sticky;
  top: 0px;
  font-weight: 600;
  font-size: 13px;
  text-decoration: underline;
  background: white;
  padding: 10px 0;
}

.selection-container section {
  padding: 0 0;
  display: flex;
  flex-wrap: wrap;
}

.selection-container .badge {
  border-radius: 100px;
  display: inline-flex;
  padding: 5px 10px;
  color: white;
  align-items: center;
  margin: 5px;

  .name {
    flex-shrink: 0;
    width: auto;
  }
}

.far.fa-eye {
  color: white;
}

.far.fa-eye-slash {
  color: #ff2213;
}

.search-result {
  height: 400px;
  overflow: auto;
  max-height: 400px;
  overflow: auto;
}
</style>
